<script>
    // Stores 
    import { alt } from '../store.js';  

    // Componentes
    import { link } from "svelte-routing";
    import PageHeader from './../components/PageHeader.svelte';

    // Code
    let titlePage = 'Documentação Necessária';    
    
    let itens = [{}];

    let documentacao = [
        {
            name: 'Locatário/Fiador Pessoa Física',
            icon: `<i class="fas fa-user"></i>`,
            list: `
                <li><p>RG e CPF</p></li>
                <li><p>Comprovante de estado civil</p></li>
                <li><p>03 últimos contracheques</p></li>
                <li><p>Cópia da declaração do imposto de renda com protocolo de entrega</p></li>
                <li><p>Cópia do comprovante de residência</p></li>
                <li><p>Ficha de cadastro preenchida e assinada</p></li>
                <li><p><b>Fiador:</b> Matrícula atualizada dos imóveis para a garantia da fiança</p></li>
            `,
        },  
    ];
</script>

<section class="conteudo-internas">
    <PageHeader title={titlePage}></PageHeader>    
    <div class="container">
        <p>Confira as documentações solicitadas para locação:</p>
        <div class="box-itens-icon mb-20">
            <div class="item">
                <div class="icon">
                    <i class="fas fa-paste"></i>
                </div>
                <div class="infos">
                    <h2 class="title text-uppercase color-primary">Documentação Necessária para Verificação Cadastral</h2>
                    <ul class="list-cycle">
                        <li>
                            Cópia da Carteira de identidade e do CPF.
                        </li>
                        <li>
                            Comprovante de residência atual.
                        </li>
                        <li>
                            Contracheques ou Imposto de Renda (últimos 3).
                        </li>
                        <li>
                            Certidão atualizada: ou de Casamento ou de Nascimento.
                        </li>
                        <li>
                            Ficha Cadastral preenchida (preferencialmente NÃO MANUALMENTE).
                        </li>
                        <li>
                            Certidão Negativa Cível e Criminal.
                        </li>
                        <a class="btn btn-primary icon-transform mt-20" href="/assets/fichas/fichasYaraImobiliaria.pdf" target="_blank" title="Clique aqui para fazer o download da ficha cadastral">
                            Download Ficha Cadastral  <i class="fas fa-download ml-10"></i> 
                        </a>
                    </ul>
                </div>
            </div>
        </div>
        <p>
            <b>Obs.:</b> Importante esclarecer que outras documentações podem ser solicitadas, de forma a viabilizar a análise cadastral, o que igualmente não envolverá reserva de imóvel, tampouco reembolso de valores eventualmente gastos pelo pretendente à locação e por seus fiadores.
        </p>
        <h2 class="title text-uppercase color-primary mt-35 mb-20 text-center no-breakline--xs">
            Observações indispensáveis e comuns aos candidatos <br> a locação e a seus fiadores
        </h2>
        <ul class="list">
            <li>
                <i class="fas fa-arrow-circle-right mr-10 color-primary"></i> As informações fornecidas são de exclusiva responsabilidade do candidato à locação e de seus fiadores, tanto no que se refere à veracidade das mesmas, quanto a estarem incompletas ou exatas.
            </li>
            <li>
                <i class="fas fa-arrow-circle-right mr-10 color-primary"></i> A entrega de documentação do candidato e de seus fiadores, e a entrega de documentos eventualmente solicitados, sob nenhuma hipótese, significa aprovação do cadastro, tampouco reserva de imóvel.
            </li>
            <li>
                <i class="fas fa-arrow-circle-right mr-10 color-primary"></i> O candidato e seus fiadores estão cientes que não está previsto reembolso de valores referentes à obtenção de quaisquer documentações, exemplificativamente: certidões, matrículas, cópias, Tabelionatos, Registro de Imóveis, diligências, entregas, Correios, enfim, qualquer tipo de emolumento e / ou taxa, etc.
            </li>
            <li>
                <i class="fas fa-arrow-circle-right mr-10 color-primary"></i> Eventual devolução de documentos de cadastros não aprovados deve ser ajustada previamente. Os documentos ficarão disponíveis pelo prazo de 30 (trinta) dias, a partir da comunicação. Depois disso, serão eliminados.            
            </li>
        </ul>
        <div class="button text-center mt-40">        
            <a href="/garantias-locaticias" use:link replace title="Confira as garantias locatícias" class="btn btn-secondary">
                Confira as garantias locatícias <div class="arrow-animate"><i class="far fa-arrow-right"></i></div> 
            </a>
        </div>        
    </div>
</section>